export default __webpack_public_path__ + "static/2-8cd73fab6f6d4380a18fafb5397d285a.jpg";